export const CHECK_GPDR_CONSENT = 'CHECK_GPDR_CONSENT';
export const IS_COOKIES_ENABLED = 'IS_COOKIES_ENABLED';
export const IS_LOCALSTORAGE_AVAILABLE = 'IS_LOCALSTORAGE_AVAILABLE';
export const SET_ROUTE = 'SET_ROUTE';
export const SET_STARTED_WIDGET = 'SET_STARTED_WIDGET';
export const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS';
export const SET_PROTOCOL = 'SET_PROTOCOL';
export const SET_TRACKING_STATUS = 'SET_TRACKING_STATUS';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LOGO = 'SET_LOGO';
export const SET_INTERNAL_STATUS = 'SET_INTERNAL_STATUS';
export const SET_IFRAME_STATUS = 'SET_IFRAME_STATUS';
export const IS_GOOGLE_TRACKER_ENABLED = 'IS_GOOGLE_TRACKER_ENABLED';
export const TOGGLE_COOKIE_DISCLAIMER = 'TOGGLE_COOKIE_DISCLAIMER';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_WIDGET_SCENE = 'SET_WIDGET_SCENE';
export const SET_PLOT_COUNT = 'SET_PLOT_COUNT';
export const SET_PROGRAM_INFO = 'SET_PROGRAM_INFO';
export const SET_SNACKBAR = 'SET_SNACKBAR';
export const SET_DISPLAY_FAVORITE = 'SET_DISPLAY_FAVORITE';
export const SET_LOADING_BACKGROUND = 'SET_LOADING_BACKGROUND';
export const SET_DISABLE_CLOSE_SIDEBAR = 'SET_DISABLE_CLOSE_SIDEBAR';
export const SET_RESOLUTION = 'SET_RESOLUTION';
export const SET_IS_FRONTLESS = 'SET_IS_FRONTLESS';
export const SET_FUNNEL = 'SET_FUNNEL';
export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
export const SET_WIDGET_TRACKING = 'SET_WIDGET_TRACKING';
export const UPDATE_WIDGET_TRACKING = 'UPDATE_WIDGET_TRACKING';
export const SET_WIDGET_TRACKING_ENABLED = 'SET_WIDGET_TRACKING_ENABLED';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js